import React, { useState, useEffect } from "react";
import { LoadingIcon } from '@prosolve/common-components-ui'
import Cookies from 'js-cookie';
import useFetch from '../../hooks/useFetch';
import Table from "../sharedComponents/Table";

export default () => {
  const userId = Cookies.get('loggedInUserId');

  const [isLoading, setIsLoading] = useState(true)
  const [modulesCompletedData, setModulesCompletedData] = useState([]);

  const fetch = useFetch();

  const fetchModulesCompletedData = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`trainer/modulesCompleted?userId=${userId}`, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setModulesCompletedData([])
      } else {
        setModulesCompletedData(jsonData)
      }
    } catch (e) {
      setModulesCompletedData([])
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchModulesCompletedData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns = [
    {
      field: 'moduleName',
      title: 'Module',
    },
    {
      field: 'timesPresented',
      title: 'Times Presented',
      headerStyle: { textAlign: 'right', paddingRight: '10px' },
      rowStyle: { textAlign: 'right', paddingRight: '20px' }
    },
  ]

  return (
    <div
      style={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{
        flex: 1,
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        marginLeft: '20px'
      }}>
        {`Modules Completed`}
      </div>
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div style={{
            flex: 1,
            padding: '20px',
            color: '#565656'
          }}>
            <div style={{
              border: '1px solid #dcdcdc',
              borderRadius: '10px',
              maxHeight: '400px',
              overflow: 'auto'
            }}>
              <Table
                columns={columns}
                data={modulesCompletedData}
              />
            </div>
          </div>
      }
    </div>
  )
}